import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { closePanelTabSelector, setPanelSelector } from '@/state/selector/panelSelector';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { IconButton } from '@material-ui/core';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { helpdeskTicketLastUserActionAtom, isShowVisibilityKnowledgeAtom } from '@/state/atom/ticketAtom';
import { multiPanelAtom } from '@/state/atom/panelAtom';

export const TicketKnowledgeHead = ({ ...props }) => {
    const panelList = useRecoilValue(multiPanelAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);

    const addNewPanel = useSetRecoilState(setPanelSelector);
    const setLastUserAction = useSetRecoilState(helpdeskTicketLastUserActionAtom);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);
    const setIsShowVisibilityKnowledgeAtom = useSetRecoilState(isShowVisibilityKnowledgeAtom);

    const selectedProject = useRecoilValue(projectInuseDetailAtom);

    const getTicketOutline = () => {
        let ticketOutline = '';

        if (!Utils.isEmptyObject(props.ticketInfo) && props.ticketInfo.outline) {
            ticketOutline = Utils.convertJSONDataToObject(props.ticketInfo.outline);
            if (typeof ticketOutline === 'object') {
                ticketOutline = ticketOutline.jp;
            }
        }

        return ticketOutline;
    };

    const onOpenKnowledge = () => {
        const existedKnowledgeHelpdeskTicketListPanel = panelList.find(
            panel => (Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST, Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type)
        );
        
        if (!Utils.isEmptyObject(existedKnowledgeHelpdeskTicketListPanel)) {
            closePanelTab({
                event: null,
                panelType: existedKnowledgeHelpdeskTicketListPanel.type,
                panelId: existedKnowledgeHelpdeskTicketListPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        let detailTicket = props.ticketInfo;
        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            isCustomer: false,
            customerId: '',
            projectSelectedId: userPermissionView.projectSelectedId,
            corporationSelectedId: userPermissionView.corporationSelectedId,
            props : {
                ...props,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            }
        }
        if (
            userPermissionView.projectSelectedId !== detailTicket.affiliationProject &&
            (userDetail?.id === detailTicket.customer || userPermissionView.projectSelectedId === detailTicket.customer)
        ) {
            setIsShowVisibilityKnowledgeAtom(false);

            addNewPanelParams.visibilitySettingType = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
            addNewPanelParams.isCustomer = true
            addNewPanelParams.customerId = detailTicket.customer
            addNewPanelParams.projectSelectedId = detailTicket.affiliationProject
            addNewPanelParams.corporationSelectedId = detailTicket.affiliationOrganization
        }
        addNewPanel(addNewPanelParams)                                                                          
    };

    const viewTicketKnowledgeDetail = async () => {
        if (!props.ticketInfo.id) {
            return;
        }

        let isProjectInuse = props.ticketInfo.affiliationProject === selectedProject.id;
        addNewPanel({
            // type: isProjectInuse ? Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL :Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL,
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
            tabId: props.ticketInfo.id,
            props,
            ticketId: props.ticketInfo.id,
            isCustomer: false,
            isTicketDeleted: !Utils.isEmptyString(props.ticketInfo?.deletedAt) ? true : false
        });
        if (setLastUserAction) {
            setLastUserAction(LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW);
        }
    };

    return (
        <div className="headTicket">
            <div className='headTicket-chat headTicket-wrap'>
                <div className='headTicket-fl'>
                    <div className='headline' onClick={viewTicketKnowledgeDetail}>
                        <div className="headline__thumb">
                            <img src="/assets/image/icon-check.svg" alt="" />
                        </div>
                        <div className="headline__content">
                            <h2 className="tlt" data-cy="ticket-header-tlt">
                                    {getTicketOutline()}
                                </h2>
                        </div>
                    </div>
                </div>

                <div className='headTicket-rg'>
                    <div className='headeLink'>
                        <IconButton className='itemTools' onClick={onOpenKnowledge}>
                            <img
                                src="/assets/image/icon-link.svg" alt=""
                            />
                        </IconButton>
                    </div>
                </div>
            </div>

            {/* <div className="ticket-lst ticket-lst--changeChat">
                <ul>
                    <li>
                        <div className="ticket-item"> */}
                            {/* <div className="itemAssignee itemAssignee--active">
                                <img src="/assets/image/imgUser.svg" alt="" />
                            </div> */}
                            {/* <div className="ticket-link">
                                <div href="javascript:void(0)">
                                    <img
                                        src="/assets/image/icon-lightBulb.svg"
                                        alt=""
                                        onClick={onOpenKnowledge}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="ticket-headline" onClick={viewTicketKnowledgeDetail}>
                            <div className="ticket-info">
                                <div className="ticket-info__thumb">
                                    <img src="/assets/image/icon-check.svg" alt="" />
                                </div>
                                <div className="ticket-info__content">
                                    <h2 className="tlt" data-cy="ticket-header-tlt">
                                        {getTicketOutline()}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div> */}
        </div>
    );
};
